import { useState } from "react"
import { SystemSS } from "../../../components/SystemSS"
import { FullScreenModal } from "../../../utility/FullScreenModal"

export const FacilitiesMarina = () => {
      const [showModal, setShowModal] = useState(false)
      const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
      const handleOpenModal = (contentType, category, index, maxIndex) => {
          setModalContent({ contentType, category, index, maxIndex })
          setShowModal(true)
      }
      const handleCloseModal = () => {
          setModalContent({ contentType: '', category: '', index: 0 })
          setShowModal(false)
      }
    return (
        <>
            {' '}
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='confine'
                        src={`${process.env.PUBLIC_URL}/images/system/system-marina.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>By strengthening your pirate ship, you are able to increase your entire party's <span className='text-pborange'>stats</span>.</p>{' '}<br/>
                    <p>
                        Depending on the pirate ship you choose, your boosted stats will change. Ships can do things like increasing the amount of EXP gained to help you level up or increasing movement and jump ability for maps with large height differences. Try choosing the best ship for your current situation! 
                    </p>{' '}
                 
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'marina',
                                index: 1,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                    />{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'marina',
                                index: 2,
                            },
                            {
                                modalId: 'marina',
                                index: 3,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                    />{' '}
                </div>
            </section>{' '}
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={3}
            />
        </>
    )}
